import React, { useState } from 'react';
import BinOutline from '../../assets/icons/Glyph/BinOutline';
import { useCharacteristicClustering } from '../../containers/MethodologyContainer/hooks/use-characteristic-clustering';
import Popover from '../popover/popover';
import AlertGlyph from '../../assets/icons/Glyph/AlertGlyph';
import TextButton from '../button/textButton';
import { TypeOptions } from '../typo/STTypo.models';

interface DeleteButtonWithPopoverProps {
  clusterId: string;
}

export function DeleteButtonWithPopover({ clusterId }: DeleteButtonWithPopoverProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { handleDeleteCluster } = useCharacteristicClustering();
  return (
    <Popover
      content={
        <div className='mr-5 drag-header__popover'>
          <div className='mr-5 drag-header__popover__content'>
            <AlertGlyph />
            <span>Are you sure you want to delete the cluster? The clustered characteristics won&apos;t be deleted</span>
          </div>
          <div className='mr-5 drag-header__popover__footer'>
            <TextButton
              text='Cancel'
              type={TypeOptions.P1}
              ariaLabel='header cancel deletion'
              className='mr-5 drag-header__popover__footer__cancel'
              onClick={() => {
                setIsOpen(false);
              }}
            />
            <TextButton
              text='Remove'
              type={TypeOptions.P1}
              ariaLabel='Header remove'
              className='mr-5 drag-header__popover__footer__remove'
              onClick={() => {
                handleDeleteCluster(clusterId);
                setIsOpen(false);
              }}
            />
          </div>
        </div>
      }
      visible={isOpen}
      handleVisibleChange={setIsOpen}>
      <button
        className='cluster-modal-footer-buttons__delete-button'
        onClick={() => {
          setIsOpen(true);
        }}
        type='button'
        data-testid='button-delete-cluster'>
        <BinOutline color='#F74141' />
        <span>Delete</span>
      </button>
    </Popover>
  );
}
